import { AssignEntityCardActionsPlugin } from './AssignEntityCardActionsPlugin';
import { AssignEntityCardPlugin } from './AssignEntityCardPlugin';
import { AssignEntityCreateButtonPlugin } from './AssignEntityCreateButtonPlugin';
import { AssignEntityDialogPlugin } from './AssignEntityDialogPlugin';
import { AssignEntityPlugin } from './AssignEntityPlugin';
import { AssignEntityUnlinkIconButtonPlugin } from './AssignEntityUnlinkIconButtonPlugin';
import { SiteCardOverPagePlugin } from './SiteCardOverPagePlugin';
import { SiteChipPlugin } from './SiteChipPlugin';
import { SiteComponentStackPlugin } from './SiteComponentStackPlugin';
import { SiteDashboardPagePlugin } from './SiteDashboardPagePlugin';
import { SiteDatePlugin } from './SiteDatePlugin';
import { SiteDialogPlugin } from './SiteDialogPlugin';
import { SiteDocumentListPagePlugin } from './SiteDocumentListPagePlugin';
import { SiteDocumentViewerPlugin } from './SiteDocumentViewerPlugin';
import { SiteKanbanBoardPagePlugin } from './SiteKanbanBoardPagePlugin';
import { SiteKanbanBoardPlugin } from './SiteKanbanBoardPlugin';
import { SiteNavigationPlugin } from './SiteNavigationPlugin';
import { SitePortalPlugin } from './SitePortalPlugin';
import { SiteRoutePlugin } from './SiteRoutePlugin';
import { SiteSubTaskListCardPlugin } from './SiteSubTaskListCardPlugin';
import { SiteTablePagePlugin } from './SiteTablePagePlugin';
import { SiteTablePlugin } from './SiteTablePlugin';
import { SiteTaskStatusActionsPlugin } from './SiteTaskStatusActionsPlugin';
import { SiteTaskStatusCardPlugin } from './SiteTaskStatusCardPlugin';
import { SiteTaskStatusLabelPlugin } from './SiteTaskStatusLabelPlugin';
import { SiteTaskStatusVersionCardPlugin } from './SiteTaskStatusVersionCardPlugin';
import { SiteTextPlugin } from './SiteTextPlugin';
import { SiteTraceBoardPagePlugin } from './SiteTraceBoardPagePlugin';
import { SiteTraceBoardPlugin } from './SiteTraceBoardPlugin';
import { SiteBarChartPlugin } from './SiteBarChartPlugin';
import { SiteButtonPlugin } from './SiteButtonPlugin';
import { SiteGridPlugin } from './SiteGridPlugin';
import { SiteGridItemPlugin } from './SiteGridItemPlugin';
import { SiteCardPlugin } from './SiteCardPlugin';
import { SiteLoginPlugin } from '../login/SiteLoginPlugin';
import { SiteForgotPasswordPlugin } from '../login/SiteForgotPasswordPlugin';
import { SiteIconButtonPlugin } from './SiteIconButtonPlugin';
import { SiteMenuItemPlugin } from './SiteMenuItemPlugin';
import { SiteDashboardCardPlugin } from './SiteDashboardCardPlugin';
import { SiteFormPlugin } from './SiteFormPlugin';
import { SiteCreateEntityDialogPlugin } from './SiteCreateEntityDialogPlugin';
import { SiteEntityStatusCardPlugin } from './SiteEntityStatusCardPlugin';
import { SitePieChartPlugin } from './SitePieChartPlugin';
import { SiteSearchPlugin } from './SiteSearchPlugin';
import { SiteQueryFieldStackPlugin } from './SiteQueryFieldStackPlugin';
import { ChartItemsDialogPlugin } from './ChartItemsDialogPlugin';
export const defaultSitePlugins = [
    SiteLoginPlugin,
    SiteForgotPasswordPlugin,
    SiteRoutePlugin,
    SiteDialogPlugin,
    SiteCreateEntityDialogPlugin,
    SiteComponentStackPlugin,
    SiteButtonPlugin,
    SiteIconButtonPlugin,
    SiteMenuItemPlugin,
    SiteNavigationPlugin,
    SitePortalPlugin,
    SitePieChartPlugin,
    SiteBarChartPlugin,
    SiteCardOverPagePlugin,
    SiteTablePagePlugin,
    SiteTablePlugin,
    SiteDashboardPagePlugin,
    SiteDocumentListPagePlugin,
    SiteDocumentViewerPlugin,
    SiteTraceBoardPagePlugin,
    SiteTraceBoardPlugin,
    SiteKanbanBoardPagePlugin,
    SiteKanbanBoardPlugin,
    SiteGridPlugin,
    SiteGridItemPlugin,
    SiteDashboardCardPlugin,
    SiteCardPlugin,
    SiteTextPlugin,
    SiteDatePlugin,
    SiteChipPlugin,
    SiteFormPlugin,
    SiteQueryFieldStackPlugin,
    SiteSearchPlugin,
    SiteEntityStatusCardPlugin,
    SiteTaskStatusLabelPlugin,
    SiteTaskStatusActionsPlugin,
    SiteTaskStatusCardPlugin,
    SiteTaskStatusVersionCardPlugin,
    SiteSubTaskListCardPlugin,
    AssignEntityPlugin,
    AssignEntityCardPlugin,
    AssignEntityCardActionsPlugin,
    AssignEntityCreateButtonPlugin,
    AssignEntityDialogPlugin,
    AssignEntityUnlinkIconButtonPlugin,
    ChartItemsDialogPlugin
];
//# sourceMappingURL=default.js.map